// 'new' macht hier keinen sinn, weil einzelne werte immer als value gemacht werden

export const Numr = { //one number operations
    validate: function (number: any): boolean {
        return Number.isFinite(number);
    },
    roll: function (num: number, step: number = 1): number {
        return num - Math.floor(num / step) * step; //ähnlich wie %
    },
    wrap(t: number): number {
        t = t % 1;
        if (t < 0) return t + 1;
        return t;
    },
    step: function (items: number, d: number) { // in items: 8, d: 0.4 -> out: a: 3, b: 4, d: 0.2
        const step = 1 / items;
        const pos = this.clamp(Math.floor(d * items), 0, items - 1);
        return { a: pos, b: pos + 1, d: d % step / step };
    },
    round: function (a: number, decimal: number): number {
        const dec = Math.pow(10, decimal);
        return Math.round(a * dec) / dec;
    },
    trunc: function (a: number, decimal: number): number {
        const dec = Math.pow(10, decimal);
        return Math.trunc(a * dec) / dec;
    },
    lerp: function (a: number, b: number, t: number = 0): number {
        return a + (b - a) * t;
    },
    snap: function (value = 33, steps = 25, tolerance = 3, min = -Infinity, max = Infinity, offset = 0): number {
        const nearestSnapPoint = Math.round((value + offset) / steps) * steps - offset;
        if (Math.abs(value - nearestSnapPoint) <= tolerance) return Math.max(min, Math.min(max, nearestSnapPoint));
        return Math.max(min, Math.min(max, value));
    },
    closest: function (value: number, numbers: number[]): number {
        return numbers.reduce((nearest, number) =>
            Math.abs(value - number) < Math.abs(value - nearest) ? number : nearest
        );
    },
    snaps: function (value = 33, steps = [0.25, 0.75], tolerance = 3): number {
        const nearestSnapPoint = this.closest(value, steps);
        if (Math.abs(value - nearestSnapPoint) <= tolerance) return nearestSnapPoint;
        return value;
    },
    precision: function (decimals: number, scale: number): number {
        return Math.max(decimals, Math.ceil(decimals + Math.log10(scale)));
    },
    clamp: function (num: number, min = 0, max = 1) {
        return Math.max(min, Math.min(max, num));
    },
    max: function (num: number, max = 1) {
        return Math.min(max, num);
    },
    min: function (num: number, min = 0) {
        return Math.max(min, num);
    },
    passing: function (before: number, now: number, passing_point = 0) {
        return (before >= passing_point && now < passing_point) || (before <= passing_point && now > passing_point);
    },
    decimals: function (value: number, decimals: number = 2): string { //0.1 -> 0.10
        const dec = Math.pow(10, decimals);
        const truncated = Math.trunc(value * dec) / dec;
        return truncated.toFixed(decimals);
    },
    decimal: function (value: number, decimals: number = 0): string { //(0.125, 1) -> "2" (gibt stelle nach punkt als string zurück)
        const shifted = value * Math.pow(10, decimals);
        const digit = Math.floor(Math.abs(shifted)) % 10;
        return digit.toString();
    },
    digits: function (value: number, digits = 2): string { //3.4948 -> "03"
        const truncated = Math.trunc(value);
        const paddedWhole = truncated.toString().padStart(digits, '0');
        return paddedWhole;
    },
    digit: function (value: number, digits = 1): string { //(489.4948, 2) -> "4" (gibt zahl an der n stelle vor punkt als string zurück)
        return digits <= 0 ? '0' : (Math.floor(Math.abs(value) / Math.pow(10, digits - 1)) % 10).toString()
    },
    zeros: function (value: number = 2.3, digits: number = 2, decimals: number = 2): string {
        2.3 //-> 02:30
        const dec = Math.pow(10, decimals);
        const truncated = Math.trunc(value * dec) / dec;
        const formatted = truncated.toFixed(decimals);
        const parts = formatted.split('.');
        const wholePart = parts[0].padStart(digits, '0');
        const decimalPart = parts[1] || '0'.repeat(decimals);
        return `${wholePart}.${decimalPart}`;
    }
};